require([
    "SitecoreFormsExtension/SitecoreFormsExtension",
    "CustomLazyLoading/CustomLazyLoading",
    "RunOnEveryPage/components/goToPageSection",
    "RunOnEveryPage/components/backToTop",
    "RunOnEveryPage/components/pdfViewerTarget"
],
    function (sitecoreFormsExtension, customLazyLoading, goToPageSection, backToTop, pdfViewerTarget) {
        sitecoreFormsExtension.init();
        customLazyLoading.init();
        goToPageSection.init();
        backToTop.init();
        pdfViewerTarget.init();
        $(document).ready(function () {
            //gtmHelper.processProductImpressions();     Google Tag Manager is not used
            //gtmHelper.processCartItems();     Google Tag Manager is not used
            //gtmHelper.processPurchase();     Google Tag Manager is not used
            //gtmHelper.prepareProductClicks();     Google Tag Manager is not used
        });
});

define("RunOnEveryPage/main", function(){});

